import * as Apice from "./lib_react_adminlte/main/Apice";
import tabReducer from "./lib_react_adminlte/template/tab/tabReducer";
import Empresa from "./telas/Cadastros/Empresa";
import Dashboard from "./telas/Cadastros/Dashboard";
import Inicio from "./telas/Cadastros/Inicio";
import Usuario from "./telas/Cadastros/Usuario";
import empresaReducer from "./utils/empresaReducer";
//import recuperarSenha from "./telas/Cadastros/recuperarSenha";
import filiaisReducer from "./utils/filialReducer";
// import Api from "./utils/Api.jsx";
import constants from "./utils/constants";
import reducerUltimaAtualizacao from "./utils/reducerUltimaAtualizacao";
import usuarioReducer from "./utils/usuarioReducer";

const opcoes = new Apice.Options();

opcoes.dispatch = (store) => {
  store.dispatch({
    type: "define_empresa",
  });
  store.dispatch({
    type: "define_ultima_atualizacao",
  });
 
};

Apice.iniciarAplicacao(
  {
    tab: tabReducer,
    filiais: filiaisReducer,
    empresa: empresaReducer,
    ultimaAtualizacao: reducerUltimaAtualizacao,
    usuario: usuarioReducer,
  },
  (redux, menuItem) => {
    let arr = [];
    arr.push(menuItem("", "Home", "fa-map", Inicio));
    if (redux.usuario.tipo_usuario == constants.tipo_usuario_admin) {
      arr.push(menuItem("usuario", "Usuario", "fa-user", Usuario));
      arr.push(menuItem("empresa", "Empresa", "fa-industry", Empresa));
    }

    arr.push(menuItem("dashboard", "Dashboard", "fa-tachometer", Dashboard));
    
    return arr;
  },
  "fa-play",
  "ERP B.I",
  "erp_bi",
  constants.url_backend,
  opcoes
);



// WEBPACK FOOTER //
// ./src/index.js